import {
  canShowSketchPropertySection,
  registerPropertyManagerSection,
  resolveSketchEntityPropertyActions,
} from '@/core';
import InsertLineSection from '@/components/editor/property-manager/insert-line/InsertLineSection.vue';

registerPropertyManagerSection({
  id: 'register-insert-line',
  title: (context) => {
    return '插入线条';
  },
  order: 8,
  component: InsertLineSection,
  actions: {
    confirm: true,
  },
  resolveActions: resolveSketchEntityPropertyActions,
  isApplicable: (context) => canShowSketchPropertySection(context, context.insertLinePropertyVisible === true),
});
